import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import CTASection from '../home/sections/CTA';

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>About Us | MrJoe.Pro - Software Built for Real Contractors</title>
        <meta name="description" content="Learn about MrJoe.Pro, contractor software built by Buildmetric LLC. We help home improvement professionals create estimates and invoices quickly without complicated software." />
        <meta name="keywords" content="about MrJoe.Pro, Buildmetric LLC, contractor software company, home improvement software, who makes MrJoe.Pro" />
        <link rel="canonical" href="https://mrjoe.pro/pub/about_us" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://mrjoe.pro/pub/about_us" />
        <meta property="og:title" content="About Us | MrJoe.Pro" />
        <meta property="og:description" content="Software built for real contractors. Fast, straightforward tools for estimates and invoices without the hassle." />
        
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="About Us | MrJoe.Pro" />
        <meta name="twitter:description" content="Software built for real contractors. Fast, straightforward tools for estimates and invoices without the hassle." />
      </Helmet>

      <section className="page-padding">
        <div className="container-safe">
          <h1 className="page-heading">About MrJoe.Pro</h1>
          <p className="mx-auto mt-7 text-lg font-medium tracking-wide md:max-w-[1008px]">
            We built MrJoe.Pro because we've seen it too many times: good contractors stuck at the kitchen table late at night, fighting spreadsheets just to get an estimate or invoice out the door. You're out there building houses, fixing plumbing, laying tile, and remodeling kitchens—you shouldn't have to wrestle with complicated software on top of it.
            <br />
            <br />
            MrJoe.Pro is made for the real world of home improvement jobs, dusty job sites, quick bids between calls, and getting paid without the hassle. It's straightforward, fast, and does exactly what you need—no fluff, no steep learning curve.
            <br />
            <br />
            MrJoe.Pro is owned and operated by Buildmetric LLC out of Florida. We listen to guys in the field and keep improving the app so you can finish the paperwork in minutes and get back to the work that matters.
            <br />
            <br />
            Have ideas or feedback? Reach out on our{" "}
            <Link to="/contact" className="underline underline-offset-5">
              Contact Us
            </Link>{" "}
            page.
          </p>
        </div>
      </section>
      <CTASection />
    </>
  );
}